import React, { useEffect, useState } from 'react';
import Input from '../../../../components/Input'
import PopupNewPassword from '../../../../components/PopupNewPassword';
import accessServices from '../../../../services/accessServices';

import './styles.css';





export default function FormAccess(props) {
    const [nome, setNome] = useState("");
    const [tipos, setTipos] = useState([]);
    const [telefone, setTelefone] = useState("");
    const [ddi, setDdi] = useState("");
    const [iso2_ddi, setIso2_ddi] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [foto, setFoto] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [visibility, setVisibility] = useState(false);

    useEffect(() => {
        if(props.access && Object.keys(props.access).length > 0) {
            setNome(props.access.nome);
            setTipos(props.access.tipos);
            setTelefone(props.access.telefone);
            setDdi(props.access.ddi);
            setIso2_ddi(props.access.iso2_ddi);
            setFoto(props.access.foto);
            setEmail(props.access.user.email);
        }

    }, [props.access])

    function onClick (e) {
        e.preventDefault();
        if (!isValid) {
            alert("Digite um número de telefone válido");
            return;
        }
        if(password != password2) {
            alert("Os campos de senha e confirmação de senha devem ser iguais.");
            return;
        }
        let fotoValue;
        fotoValue = props.access ? (props.access.foto !== foto ? foto : null) : foto;
        props.onClick({nome, telefone, ddi, iso2_ddi, tipos, foto: fotoValue,email, password})
    }
    return (
        <form className='access-form' action=''>
            <h4>{props.title}</h4>
            <Input
                label="Nome*"
                placeholder="Nome"
                id="access-form-nome"
                onChange={(e) => setNome(e.target.value)}
                value={nome}
            />

            <Input
                label='Foto'
                type='photo'
                accept="image/*"
                placeholder="Selecione uma foto"
                showFileLabel
                filePreview
                id='edit-access-form-photo'
                className='edit-access-form-photo'
                onChange={setFoto}
                value={foto ? (typeof foto === "string" ? foto : URL.createObjectURL(foto)) : ''}
            />

            <Input
                label='Telefone*'
                type='tel'
                placeholder="Telefone"
                id='academy-form-phone'
                onChange={(event) => setTelefone(event.target.value)}
                iso2={iso2_ddi}
                setIso2={setIso2_ddi}
                setDialCode={setDdi}
                setIsValidNumber={setIsValid}
                value={telefone}
            />

            <Input
                label="Email*"
                placeholder="Email"
                id="access-form-email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
            />

{
                !props.edit ?
                <>
                    <Input
                        label="Senha*"
                        placeholder="Senha"
                        id="access-form-senha"
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                    />

                    <Input
                        label="Confirmação de Senha*"
                        placeholder="Confirmação de Senha"
                        id="access-form-confirmacao-senha"
                        onChange={(e) => setPassword2(e.target.value)}
                        value={password2}
                    />
   
                </>
                :
                <>
                    <button className="access-form-password-button" onClick={(e) => {
                        e.preventDefault();
                        setVisibility(true);
                        }}
                    >
                        Editar Senha
                    </button>
                    <PopupNewPassword
                        visibility={visibility}
                        setVisibility={setVisibility}
                        password={password}
                        confirmPassword={password2}
                        setPassword={setPassword}
                        setConfirmPassword={setPassword2}
                        onClick={() => setVisibility(false)}
                        buttonTitle="Fechar"
                    />
                </>


            }


            
            <button className="access-form-submit-button" onClick={onClick}>
                {props.buttonTitle}
            </button>

        </form>
    )
}